/**
 * ** Cloudbeds **
 *
 * @exports partnership_234
 * @category partnerships
 */
function factory({ window, document, thn }) {

  const partnership = {};

  /**
     * @memberOf module:partnership_234
     */
  partnership.getId = function getId() {
    return '234';
  };

  /**
     * @memberOf module:partnership_234
     */
  partnership.check = function check() {
    return !!window.location.hostname.match(/\.cloudbeds\.com$/);
  };

  /**
     * @memberOf module:partnership_234
     */
  partnership.getSiteId = function getSiteId() {
    return window.createdBooking
            && window.createdBooking.widget_property;
  };

  return partnership;
}

export { factory };
